import { render, staticRenderFns } from "./attachmentPdf.vue?vue&type=template&id=d820a69c&scoped=true&"
import script from "./attachmentPdf.vue?vue&type=script&lang=js&"
export * from "./attachmentPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d820a69c",
  null
  
)

export default component.exports